<!-- components/ComHeader.vue -->
<template>
	<div class="main Com-header">
		<div class="flex-betweenStart">
			<div class="cursor-active" @click="$toPage('/')">
				<!-- ||require('@/assets/images/logo.png') -->
				<img :src="loginInfo.pc_logo" class="logo">
			</div>
			<div class="search-card flex-startCenter border-radius8 border-blue bg-blue">
				<div class="border-radius8 bg-white search-wrap">
					<el-input placeholder="查大学、查专业、问报考" border="none" maxlength="100" v-model="keyWord" @change="toSaerch">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</div>
				<div class="search-btn" @click="toSaerch">搜索</div>
			</div>
			<div class="flex-endCenter">
				<div class="flex-endCenter margin-right20 color-black">
					<div class="margin-left10 flex-startCenter">
						{{provinceName}}
						<el-divider direction="vertical" v-if="user.subject"></el-divider>
						<div v-else class="color-blue cursor-active margin-left5 margin-right5" @click="provinceVisible=true">
							{{provinceName?'[切换]':'选择省份'}}
						</div>
					</div>

					<div class=" flex-endCenter cursor-active" @click="infoShow()">
						{{user.subject}}
						<el-divider direction="vertical"></el-divider>
						{{user.score}}分
						<img src="@/assets/images/icon-edit.png" alt="编辑" class="width16 height16 margin-left5" />
					</div>
					<div class="flex-endCenter color-black" v-if="hasLogin">
						<div class="margin-left20 flex-endCenter headerAvatar">
							<img v-if="userInfo&&userInfo.avatar" :src="userInfo.avatar" alt=""
								class="width32 height32 border-radius50p" />
							<img v-else src="@/assets/images/avatar.png" alt="" class="width32 height32" />
							<i class="el-icon-arrow-down"></i>
							<div class="logout">
								<div class="" v-for="(item,index) in userList" :key="index">
									<div v-if="item.name=='我的志愿表'">
										<!-- 是svip -->
										<div v-if="userInfo.is_svip" class="height40 line-height40 padding-left20 padding-right20 user-item"
											@click="userListChange(index, 'pool',item.other)">
											{{item.name}}
										</div>
										<!-- 不是svip 省份开通 -->
										<div v-if="(volunStatus.status == 2 || volunStatus.status == 3) && !userInfo.is_svip"
											class="height40 line-height40 padding-left20 padding-right20 user-item"
											@click="userListChange(index,'volunteer?id=2',item.other)">
											{{item.name}}
										</div>
									</div>
									<div v-else class="height40 line-height40 padding-left20 padding-right20 user-item"
										@click="userListChange(index, item.path,item.other)">
										{{item.name}}
									</div>
								</div>
								<div class="height40 line-height40 padding-left20 padding-right20 user-item" @click="logout">
									退出登录
								</div>
							</div>
						</div>
						<div v-if="!userInfo.is_vip||!userInfo.is_svip" class="flex-center margin-left15 btn-vip"
							:class="!userInfo.is_vip?'':'btn-svip'" @click="showVip">
							<img src="@/assets/images/vip.png" alt="" class="width20 height20" />
							开通{{!userInfo.is_vip?'VIP':'SVIP'}}
						</div>
					</div>
				</div>
				<ComButton v-if="!hasLogin" class="margin-right26" name="登录/注册" @btnClick="showLogin"></ComButton>
				<div class="position-relative updown">
					<ComButton name="微信小程序"></ComButton>
					<div class="position-absolute updown-show" style="top:30px; left: 0;">
						<div class="border-white border-radius10 bg-white padding10 width200 height200 flex-center">
							<img class="width200 height200" :src="loginInfo.wechat_qrcode" alt="" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<nav class="nav">
			<el-menu :default-active="activeIndex" mode="horizontal" active-text-color="#1D64FF" @select="handleSelect">
				<el-menu-item index="1" @click="$toPage('/')">首页</el-menu-item>
				<el-menu-item index="2" @click="$toPage('school')">查大学</el-menu-item>
				<el-menu-item index="3" @click="$toPage('special')">查专业</el-menu-item>
				<!-- 是svip -->
				<el-menu-item v-if="userInfo.is_svip" index="4" class="menu-orange" @click="$toPage('pool',false)">
					<img src="@/assets/images/icon-hot.png" class="width18 height18" alt="" />
					SVIP志愿填报</el-menu-item>
				<!-- 不是svip 省份开通 -->
				<el-menu-item v-if="(volunStatus.status == 2 || volunStatus.status == 3) && !userInfo.is_svip" index="4"
					class="menu-orange" @click="$toPage('volunteer',false)">
					<img src="@/assets/images/icon-hot.png" class="width18 height18" alt="" />
					志愿填报</el-menu-item>
				<el-menu-item index="5" @click="$toPage('course')">考涯学堂</el-menu-item>

				<el-submenu index="6">
					<template slot="title">测评中心</template>
					<el-menu-item v-for="(item, index) in evaluateList" :key="item.id || index" :index="`6-${index + 1}`"
						@click="item.id==4 ? $toPage('/user/evaluate') : $toPage(`/evaluate?type=${item.id}`)">
						{{ item.name || '未知测评' }}
					</el-menu-item>
				</el-submenu>

				<el-submenu index="7">
					<template slot="title">考涯服务</template>
					<el-menu-item :index="'7-'+item.type" v-for="(item,index) in serviceList" :key="index"
						@click="$toPage(`/service?id=${item.id}`)">
						{{item.name}}
					</el-menu-item>
				</el-submenu>
			</el-menu>
		</nav>
		<GlobalProvince :visible="provinceVisible" @confirm="provinceConfirm" @close="provinceVisible=false">
		</GlobalProvince>
		<ChangeInfo :visible="infoVisible" @confirm="infoConfirm" @close="infoVisible=false"></ChangeInfo>
		<!-- <VipBuy :visible="vipBuy" @close="vipBuy=false"></VipBuy> -->
	</div>
</template>

<script>
	import * as evaluateApi from '@/api/evaluate'
	import * as volunApi from '@/api/volunteer'
	import {
		headuser,
		examinfo,
		footer
	} from '@/api/com'
	import {
		baseURL
	} from '@/utils/url'

	export default {
		name: 'ComHeader',
		props: {
			pageTitle: {
				type: String,
				default: '首页'
			}
		},
		data() {
			return {
				userList: [{
					name: '个人信息',
					path: 'profile'
				}, {
					name: '我的志愿表',
					path: 'volunteer',
					other: 2
				}, {
					name: '我的测评',
					path: 'evaluate'
				}, {
					name: '学习记录',
					path: 'study'
				}, {
					name: '我的订单',
					path: 'vip'
				}, {
					name: '我的收藏',
					path: 'collect'
				}, {
					name: '帮助中心',
					path: 'help'
				}, {
					name: '意见反馈',
					path: 'feedback'
				}, {
					name: '关于我们',
					path: 'about'
				}, {
					name: '平台协议',
					path: 'agreement'
				}],
				vipBuy: false,
				keyWord: '',
				activeIndex: '1',
				evaluateList: [],
				hasLogin: !!localStorage.getItem('token'),
				user: {},
				provinceName: '',
				provinceId: '',
				provinceVisible: false,
				infoVisible: false,
				serviceList: [{
					name: '高校专项计划',
					url: '/service',
					id: 1
				}, {
					name: '强基计划',
					url: '/service',
					id: 2
				}, {
					name: '综合评价',
					url: '/service',
					id: 3
				}, {
					name: '留学',
					url: '/service',
					id: 4
				}],
				userInfo: '',
				headuser: '',
				loginInfo: '',
				volunStatus: ''
			}
		},
		created() {
			this.setActiveIndexByRoute(this.$route.path)
			this.provinceName = localStorage.getItem('provinceName') || ''
			this.provinceId = localStorage.getItem('provinceId') || ''

			if (!this.provinceId) {
				this.provinceVisible = true
			}
			// 登录成功
			this.$bus.$on('loginSuccess', (res) => {
				localStorage.setItem('token', res.token)
				localStorage.setItem('provinceId', res.province_id)
				this.hasLogin = true
				this.$router.go(0)
				// this.reloadHeader(true)
			})

			// 用户信息保存
			this.$bus.$on('userInfoSaved', () => {
				this.reloadHeader(true)
			})

			// 省份切换
			this.$bus.$on('provinceIdChanged', (newProvinceId) => {
				// this.provinceId = newProvinceId
				localStorage.setItem('provinceId', newProvinceId)
				// this.provinceName = localStorage.getItem('provinceName') || ''
				this.$router.go(0)
				// this.reloadHeader(true)
			})


			this.reloadHeader(true) // 初始化加载
			this.getEvaluateType()
		},
		beforeDestroy() {
			this.$bus.$off('loginSuccess')
			this.$bus.$off('userInfoSaved')
			this.$bus.$off('provinceIdChanged')
		},
		watch: {
			// 切换页面
			'$route'(to) {
				if (to.path != '/search') {
					this.keyWord = ''
				}
				this.setActiveIndexByRoute(to.path)
				this.reloadHeader(true)
			}
		},
		methods: {
			// 带参数控制是否发请求
			reloadHeader(needRequest = false) {
				this.provinceName = localStorage.getItem('provinceName') || ''
				this.provinceId = localStorage.getItem('provinceId') || ''
				this.hasLogin = !!localStorage.getItem('token')

				// 只有传 true 才发请求
				if (needRequest) {
					this.getHeaduser()
				}
			},

			getHeaduser() {
				let req = {}
				if (this.provinceId) {
					req = {
						province_id: this.provinceId
					}
				}
				headuser(req).then(res => {
					this.user = res.data
					this.provinceName = res.data.province_name || ''
					this.provinceId = res.data.province_id || ''
					this.headuser = res.data
					localStorage.setItem('provinceName', res.data.province_name)
					localStorage.setItem('provinceId', res.data.province_id)
					localStorage.setItem('headuser', JSON.stringify(res.data))
					if (res.data) {
						this.showVlon(res.data)
					}
				}).catch(err => {
					console.log(err.errmsg)
				})
				footer().then(res => {
					this.loginInfo = res.data
				})
				if (this.hasLogin) {
					examinfo(req).then(res => {
						this.userInfo = res.data
						localStorage.setItem('userInfo', JSON.stringify(res.data))
					}).catch(err => {
						console.log(err.errmsg)
					})
				}
			},
			showVlon(val) {
				volunApi.recommend({
					province_id: val.province_id,
					subject_ids: val.subject_ids,
					batch_name: val.batch_name,
					discounted_score: val.discounted_score,
				}).then(res => {
					if (res.data) {
						this.volunStatus = res.data
					}
				}).catch(err => {})
			},
			setActiveIndexByRoute(path) {
				if (path === '/') {
					this.activeIndex = '1';
				} else if (path.startsWith('/school')) {
					this.activeIndex = '2';
				} else if (path.startsWith('/special')) {
					this.activeIndex = '3';
				} else if (path.startsWith('/volunteer') || path.startsWith('/intellect') || path.startsWith('/pool')) {
					this.activeIndex = '4';
				} else if (path.startsWith('/course')) {
					this.activeIndex = '5';
				} else if (path.startsWith('/evaluate')) {
					this.activeIndex = '6';
				} else if (path.startsWith('/service')) {
					this.activeIndex = '7';
				} else if (
					path.startsWith('/profession') ||
					path.startsWith('/same') ||
					path.startsWith('/line') ||
					path.startsWith('/rank') ||
					path.startsWith('/srank') ||
					path.startsWith('/upgrade') ||
					path.startsWith('/graduate') ||
					path.startsWith('/news') ||
					path.startsWith('/user') ||
					path.startsWith('/search')
				) {
					this.activeIndex = '1';
				}
			},

			handleSelect(index) {
				this.activeIndex = index;
			},
			// 展示购买
			showVip() {
				if (!this.headuser.is_improve) {
					this.$message.warning('请先完善信息')
					this.infoShow()
					return false
				}
				// this.vipBuy = true
				this.$bus.$emit('showVipbuy')
			},

			showLogin() {
				this.$bus.$emit('showLoginModal')
			},

			async getEvaluateType() {
				try {
					const res = await evaluateApi.type()
					this.evaluateList = res.data || []
				} catch (error) {
					this.$message.error('加载测评类型失败，请稍后重试');
				}
			},
			// 切换省份
			provinceConfirm(name, id) {
				// this.provinceName = name
				// this.provinceId = id
				// this.provinceVisible = false
				// this.reloadHeader(true)
				window.location.href = '/'
			},
			// 修改信息，修改完跳转首页
			infoConfirm() {
				this.infoVisible = false
				// this.$router.go(0)
				// location.reload();
				window.location.href = '/'
				// + '/pc'
				// setTimeout(function() {
				// 	window.location.reload()
				// }, 500)

			},
			// 展示修改信息
			infoShow() {
				if (!this.hasLogin) {
					this.$bus.$emit('showLoginModal')
					return false
				}
				this.infoVisible = true
			},
			// 点击切换菜单
			userListChange(index, path, other) {
				if (other) {
					this.$router.push(`/${path}`)
				} else {
					this.$router.push(`/user/${path}`);
				}
			},
			// 跳转页面（支持新窗口）
			goPage(path, isNew = true) {
				if (isNew) {
					window.open(path, '_blank')
				} else {
					this.$router.push({
						path: path,
					})
				}
			},
			/**
			 * 页面跳转
			 * @param {string|object} config - 配置对象或路径字符串
			 * @param {boolean} isNewTab - 是否在新标签页打开
			 */
			toPage11(config, isNewTab = true) {
				let finalPath = '';

				if (typeof config === 'string') {
					finalPath = config.startsWith('/') ? config : `/${config}`;
				} else if (typeof config === 'object') {
					const {
						path,
						id,
						params = {}
					} = config;
					finalPath = id ? `/${path}/${id}` : `/${path}`;

					// 如果有查询参数，可以添加
					if (Object.keys(params).length > 0) {
						const queryString = new URLSearchParams(params).toString();
						finalPath += `?${queryString}`;
					}
				}

				const routeData = this.$router.resolve({
					path: finalPath
				});

				if (isNewTab) {
					window.open(routeData.href, '_blank');
				} else {
					this.$router.push({
						path: finalPath
					});
				}
			},


			toSaerch() {
				if (!this.hasLogin) {
					this.$bus.$emit('showLoginModal')
					return
				}

				this.$router.push({
					path: '/search',
					query: {
						search: this.keyWord
					}
				});
			},
			logout() {
				// localStorage.removeItem('headuser')
				// localStorage.removeItem('token')
				// localStorage.removeItem('svip')
				// localStorage.removeItem('userInfo')
				localStorage.clear()
				sessionStorage.clear()

				// 重置头部状态
				this.hasLogin = false
				this.user = {}
				this.$message.success('退出成功')
				window.location.href = '/';
				// window.location.href = baseURL + '/pc'

				// 跳回首页并强制刷新（重新请求所有数据）
				// setTimeout(function() {
				// 	window.location.reload()
				// }, 500)

			}
		}
	}
</script>

<style lang="scss" scoped>
	.headerAvatar {
		position: relative;

		.logout {
			width: 120px;
			padding: 10px;
			border-radius: 4px;
			background-color: #fff;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
			display: none;
			position: absolute;
			top: 100%;
			left: 0;
			z-index: 9;
			color: #303133;

			.user-item {
				cursor: pointer;

				&:hover {
					color: #28b05e;
				}
			}
		}

		&:hover {
			.logout {
				display: block;
			}
		}
	}

	.Com-header {
		padding-top: 40px;
		border-bottom: 1px solid #eee;
		margin-bottom: 20px;
	}

	.search-card {
		height: 42px;

		.search-wrap {
			width: 338px;
			margin-left: 1px;

			::v-deep .el-input__inner {
				height: auto !important;
				border: none;
				border-radius: 8px;
			}
		}

		.search-btn {
			padding: 0 32px;
			font-size: 17px;
			color: #fff;
			cursor: pointer;
		}
	}

	.btn-vip {
		width: 87px;
		height: 28px;
		color: #fff;
		border-radius: 4px;
		background: linear-gradient(to right, #FF9915 20%, #FF6910 70%);
		cursor: pointer;
	}

	.btn-svip {
		color: #774117;
		background: linear-gradient(to right, #F4D5B0 20%, #E3B674 70%);
	}

	.logo {
		width: 180px;
		// height: 50px
	}

	.nav {
		margin-top: 15px;

		::v-deep {
			.el-menu {
				background: none !important;
				display: flex;
				justify-content: space-between;

				.el-menu-item {
					font-size: 19px;
					font-weight: bold;
					padding: 0;
					margin: 0;
					width: calc(1200px / 9);
					color: #303133;
					text-align: center;

					>a {
						display: inline-block;
						color: #303133 !important;

						&:hover {
							color: #28b05e !important;
							border-bottom: 2px solid #1D64FF;
						}
					}


					&:focus,
					&.is-active,
					&:hover {
						background: none !important;
						color: #28b05e !important;
						border: none;

						>a {
							color: #28b05e !important;
							border-bottom: 2px solid #1D64FF;
						}
					}
				}

				.menu-orange {
					color: #FF6910;

					&:focus,
					&.is-active,
					&:hover {
						background: none !important;
						color: #FF6910 !important;
						border: none;

						>a {
							color: #FF6910 !important;
							border-bottom: 2px solid #FF6910;
						}
					}
				}

				.el-submenu__title {
					font-size: 19px;
					font-weight: bold;
					padding: 0;
					margin: 0;
					color: #303133 !important;
					width: calc(1200px / 9);
					text-align: center;

					&:hover,
					&:focus,
					&:hover {
						background: none !important;
					}

					>a {
						display: inline-block;
						color: #303133 !important;

						&:hover {
							color: #28b05e !important;
							border-bottom: 2px solid #1D64FF;
						}
					}

				}
			}

			.el-menu.el-menu--horizontal {
				border-bottom: solid 1px #EBEEF5;
			}
		}
	}

	.updown-show {
		display: none;
	}

	.updown:hover {
		.updown-show {
			display: block;
		}
	}

	.el-menu--popup {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		min-width: 120px;
		padding: 10px;
		border-radius: 4px;

		.el-menu-item {
			height: 40px;
			line-height: 40px;
			padding-left: 20px;
			padding-right: 20px;

			>a {
				display: inline-block;
				color: #303133 !important;

				&:hover {
					color: #28b05e !important;
				}
			}
		}
	}
</style>
